module.exports = __webpack_public_path__ + "dummy.png";